// extracted by mini-css-extract-plugin
module.exports = {"wave2TeaserA":"A_wave2TeaserA__x8KX_"};